import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

// rxjs
import { fromRouterActions } from '@amfam/shared/utility/navigation';
// Models
import { ConfirmationModel, LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'ds-coverage-change-send-quote-confirmation',
  templateUrl: './coverage-change-send-quote-confirmation.component.html',
  styleUrls: ['./coverage-change-send-quote-confirmation.component.scss'],
  standalone: false
})
export class CoverageChangeSendQuoteConfirmationComponent implements OnInit {
  confirmationData: ConfirmationModel;

  constructor(
    private store: Store<fromRoot.RootState>,
    private pageTitle: PageTitleService,
    private spinner: LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.spinner.stop();
    this.pageTitle.set('Changes to <Policy> Sent To Agent');
    this.buildConfirmationData();
  }

  buildConfirmationData() {
    this.confirmationData = {
      confirmation: {
        heading: `We have sent your requested changes to your agent for review.`,
        infoText: `Once they have received the request, your agent will connect with you to discuss the changes.`
      }
    };
  }

  routeToPolicies() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies']
      })
    );
  }

  routeToRiskSelection() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/coverage-change']
      })
    );
  }
}
